import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { ReactNode } from "react";

import { queryClient } from "@/lib/query-client";

/**
 * Wires the shared `queryClient` (src/lib/query-client.ts — a standalone
 * module, not created here, so src/lib/interceptors.ts can also reach it)
 * into the tree. Devtools are dev-only.
 */
export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
